import { render, staticRenderFns } from "./IntakeForm.vue?vue&type=template&id=85a6eb36&"
import script from "./IntakeForm.vue?vue&type=script&lang=js&"
export * from "./IntakeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports